import React from "react";
import FilesUpload from "nbugs-files-upload";
import { List, Divider } from "antd";

import styles from "./NormDetail.less";
import { ENV } from "../../../../../services/utils";

const { Item } = List;

function NormDetail({
  number,
  name,
  remark,
  appendix,
  score,
  measurement,
  checkPoint,
  type,
  from,
  templateType
}) {
  const isShowNowForm =
    templateType === 1 || templateType === 2 || type === 1 || type === 2;
  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const { orgType: nowOrgType } = currentUser;

  return (
    <div className={styles.normDetail}>
      <div className="normDetailTitle">
        <Divider orientation="left">指标情况</Divider>
      </div>
      <div className="normDetailNews">
        <Item>
          <span className="itemName">指标编号</span>:
          <span style={{ marginLeft: 16 }}>{number}</span>
        </Item>
        <Item>
          <span className="itemName">指标名称</span>:
          <span style={{ marginLeft: 16 }}>{name}</span>
        </Item>
        <Item>
          <span className="itemName">评估标准</span>:
          <span style={{ marginLeft: 16 }}>{measurement}</span>
        </Item>
        {isShowNowForm && (
          <Item>
            <span className="itemName">备注说明</span>:
            <span style={{ marginLeft: 16 }}>{remark}</span>
          </Item>
        )}
        {isShowNowForm && (
          <Item>
            <span className="itemName">量化考核点</span>:
            <span style={{ marginLeft: 16 }}>{checkPoint}</span>
          </Item>
        )}
        {isShowNowForm && (
          <Item>
            <span className="itemName">指标分值</span>:
            <span style={{ marginLeft: 16 }}>{score}分</span>
          </Item>
        )}
        <Item>
          <span className="itemName">考评模板</span>:
          <div className="fieldsUpload" style={{ marginLeft: 16 }}>
            {appendix ? (
              <FilesUpload
                edit={1}
                type="pc"
                APIEnv={ENV}
                groupId={appendix}
                previewUrl={`//${window.location.hostname}/v2/preview/file`}
                key={appendix}
              />
            ) : (
              "-"
            )}
          </div>
        </Item>
      </div>
    </div>
  );
}

export default NormDetail;
